import { TabsProps, Tabs } from 'antd';
import { AddingImages, AddingInfo, AddingVideo, Layout, Button } from '../../components';
import { useEffect, useState } from 'react';
import { fetchCoctail, getCoctailById } from '../../store/coctailsSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './CoctailEddingPage.module.scss';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { ICoctail } from '../../types';
import { VIEW_COCKTAIL_PAGE } from '../../lib';

const CoctailEddingPage = ({ logOut }: { logOut: () => void }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idCoctail = queryParams.get('id');
  const dispatch = useAppDispatch();
  const { data, loading } = getCoctailById(useAppSelector(state => state.coctailsReducer));
  const navigate = useNavigate();
  const [coctail, setCoctail] = useState<ICoctail>(data);

  useEffect(() => {
    setCoctail(data);
  }, [data]);

  useEffect(() => {
    dispatch(fetchCoctail({ id: idCoctail }));
  }, []);

  const onViewCpctail = () => {
    navigate(`${VIEW_COCKTAIL_PAGE}?id=${coctail._id}`);
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Image',
      children: <AddingImages coctail={coctail} action={'edit'} setCoctail={setCoctail} />,
    },
    {
      key: '2',
      label: 'Video',
      children: <AddingVideo coctail={coctail} action="edit" setCoctail={setCoctail} />,
    },
    {
      key: '3',
      label: 'Information',
      children: <AddingInfo coctail={coctail} action="edit" setCoctail={setCoctail} />,
    },
  ];

  return (
    <Layout
      logOut={logOut}
      loading={loading}
      title={
        <div>
          <div className={styles.layoutTitle}>
            <div>
              Edding cocktail{' '}
              <span
                style={{
                  color: '#23b1fa',
                  fontWeight: 600,
                }}
              >
                {coctail?.eng?.name}
              </span>
            </div>
            <Button label={'View cocktail'} bg="#000" color="#fff" onClick={onViewCpctail} />
          </div>
        </div>
      }
    >
      {!loading && (
        <div className={styles.container}>
          <Tabs defaultActiveKey="1" items={items} type="card" />
        </div>
      )}
    </Layout>
  );
};

export default CoctailEddingPage;
